import * as React from 'react';
import {connect} from "react-redux";
import classnames from "classnames";
import PropTypes from "prop-types";
import {Col, Input, Row, CardBody, Tooltip} from "reactstrap";
import {injectIntl} from "react-intl";

function CafeteryWrapInput(props) {
	const {onChange, inputProps, dataId, value, placeholder, intl, error} = props

	const getPlaceholder = () => {
		if (placeholder) {
			return intl.formatMessage({id: placeholder})
		}

		return intl.formatMessage({id: 'question.input.placeholder.typeYourAnswer'})
	}

	return (
		<div className={classnames({
				"cafetery-wrap d-flex flex-column w-100 standalone-input": true,
				"error": error
			})}>
			<div className={"align-items-center d-flex opened"}>
				<div className="d-flex w-100"><Input placeholder={getPlaceholder()} {...inputProps}
					className={classnames({
					'': true,
					})}
					data-id={dataId} bsSize="sm" onChange={onChange} value={value || ''}/>
				</div>
			</div>
		</div>
	);
}

CafeteryWrapInput.propTypes = {
	onChange: PropTypes.any,
	inputProps: PropTypes.any,
	dataId: PropTypes.any,
	value: PropTypes.any,
	placeholder: PropTypes.any,
	error: PropTypes.any
};

function mapStateToProps(state) {
	return {}
}

export default connect(mapStateToProps, {})(injectIntl(CafeteryWrapInput));